import {JobModel} from "./job.model";

export enum JobSuggestionDecision {
  APPROVED = "APPROVED",
  DENY = "DENY",
  OPTIMIZE = "OPTIMIZE"
}

export enum JobSuggestionStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  REVERTED = "REVERTED"
}

export enum JobSuggestionsType {
  SPLIT_PACKAGES = 'SPLIT_PACKAGES',
  SPLIT_LOCATION = 'SPLIT_LOCATION'
}

export enum SuggestionStrategy {
  DEFAULT = "DEFAULT"
}

export interface JobSuggestion {
  id: string;
  siteId: string;
  projectId: string;
  draftId: string;
  sourceId: string;
  referencedJobId?: string;
  status: JobSuggestionStatus;
  suggestionInformation: {
    type: JobSuggestionsType;
    strategy: SuggestionStrategy;
    originalJobSnapshot: JobModel;
    subJobs: JobModel[];
    undoBlockedByStepAt?: Date;
  }
  createdAt: Date;
  updatedAt: Date;
}
